import { render, staticRenderFns } from "./roleprojectsetting.vue?vue&type=template&id=028bbf4e&"
import script from "./roleprojectsetting.vue?vue&type=script&lang=js&"
export * from "./roleprojectsetting.vue?vue&type=script&lang=js&"
import style0 from "./roleprojectsetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports